import ReactGA from 'react-ga4'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { loggingService } from '@/services/logging-service'

export const PageTracker = () => {
  const location = useLocation()

  useEffect(() => {
    ReactGA.send('pageview')
    loggingService?.startTransaction(location.pathname, 'route-change', {
      managed: true,
    })
  }, [location])

  return <></>
}
